import styled from 'styled-components';
import { Tooltip } from 'react-tooltip';

type Props = {
  dimensions: { aspectRatio: string; isPublished: boolean }[];
  selectedDimension: string;
  onSelectDimension: (dimension: string) => void;
};

const DimensionsSelector = ({
  dimensions,
  selectedDimension,
  onSelectDimension,
}: Props) => {
  return (
    <Container>
      {dimensions.map((dimension) => (
        <DimensionButton
          disabled={!dimension.isPublished}
          key={dimension.aspectRatio}
          isSelected={dimension.aspectRatio === selectedDimension}
          onClick={() => onSelectDimension(dimension.aspectRatio)}
          data-tooltip-id={
            !dimension.isPublished
              ? `dimension-${dimension.aspectRatio}-tooltip`
              : undefined
          }
          data-tooltip-content="Draft"
        >
          {dimension.aspectRatio}
          {!dimension.isPublished && (
            <Tooltip
              id={`dimension-${dimension.aspectRatio}-tooltip`}
              style={{
                padding: '8px',
                fontSize: '10px',
                lineHeight: '120%',
                zIndex: '10',
              }}
            />
          )}
        </DimensionButton>
      ))}
    </Container>
  );
};

export default DimensionsSelector;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DimensionButton = styled.button<{
  isSelected: boolean;
}>`
  background-color: transparent;
  color: ${(props) => (props.isSelected ? '#030419' : '#17c964')};
  border: 1px solid ${(props) => (props.isSelected ? 'transparent' : '#17c964')};
  background-color: ${(props) =>
    props.isSelected ? '#17c964' : 'transparent'};
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  &:disabled {
    cursor: not-allowed;
    color: #484848;
    border-color: #484848;
    background-color: transparent;
  }
`;
